// extracted by mini-css-extract-plugin
module.exports = {"contact":"_3-iCfMpgbvTjnFcn42hD_8","submit":"_2JflUJhBlah7d8hSPHofX2"};